import {create} from 'zustand';
import _get from 'lodash/get';
import {SelectChangeEvent} from '@mui/material';
import {toNumber} from 'lodash';
import {GridSortModel} from '@mui/x-data-grid';

interface DashboardServiceRequestsTableStore {
  page: number;
  size: number;
  sortModel?: GridSortModel | undefined;
  order: () => string;
  resetDashboardServiceRequestsTablePagination: () => void;
  setDashboardServiceRequestsTablePage: (_: unknown, page: number) => void;
  setDashboardServiceRequestsTableSize: (e: SelectChangeEvent<number>) => void;
  setDashboardServiceRequestsTableSort: (sortModel: GridSortModel) => void;
}

const defaultSortOrder: GridSortModel = [{field: 'startDate', sort: 'asc'}];
const defaultPage = 0;
const defaultSize = 100;

export const useDashboardServiceRequestsTableStore = create<DashboardServiceRequestsTableStore>((set, get) => ({
  page: defaultPage,
  size: defaultSize,
  sortModel: defaultSortOrder,
  order: () => {
    const sort = _get(get(), 'sortModel.[0]');
    if (!sort) return `${defaultSortOrder[0]?.field},${defaultSortOrder[0]?.sort}`;
    return `${sort?.field},${sort?.sort}`;
  },
  resetDashboardServiceRequestsTablePagination: () => set({page: defaultPage, size: defaultSize}),
  setDashboardServiceRequestsTablePage: (_, page) => set({page}),
  setDashboardServiceRequestsTableSize: (e) => set({size: toNumber(_get(e, 'target.value', defaultSize))}),
  setDashboardServiceRequestsTableSort: (sortModel) => {
    set({sortModel});
  },
}));

export const {
  resetDashboardServiceRequestsTablePagination,
  setDashboardServiceRequestsTablePage,
  setDashboardServiceRequestsTableSize,
  setDashboardServiceRequestsTableSort,
} = useDashboardServiceRequestsTableStore.getState();
